export default __webpack_public_path__ + "static/media/etapa4.fb573401.png";